<template>
  <v-flex v-if="!showEditor">
    <span class="primary-color" v-if="title">
      <strong>{{ title }}</strong>
    </span>
    <!--If index given then the function should be changePhoto(index) and uploadPhoto(index, $event)-->
    <v-card
      v-if="index > 0"
      :class="type == 'SQUARE' ? 'business-registration-photo' : 'logo-registration-photo'"
      class="center my-5"
      @click="changePhoto(index)"
    >
      <v-img cover :src="photo" />
      <input
        :ref="'BP' + index"
        style="display: none;"
        type="file"
        accept="image/*"
        @change="uploadPhoto(index, $event)"
      />
    </v-card>
    <!--If no index given then the function should be addCardClick(NO PARAM) and addPhoto($event)-->
    <v-card
      v-else
      :class="type == 'SQUARE' ? 'business-registration-photo' : 'logo-registration-photo'"
      class="center my-5"
      @click="addCardClick"
    >
      <v-img cover :src="photo" />
      <input
        ref="addPhotoInput"
        style="display: none;"
        type="file"
        accept="image/*"
        :multiple="multiFlag"
        max="10"
        @change="addPhoto($event)"
      />
    </v-card>
    <v-btn v-if="titleEditor" class="remove-business-photo mb-3" @click="showEditor = !showEditor;"
      color="orange accent-3" text>
      <v-icon>fas fa-edit</v-icon>
    </v-btn>
    <v-btn v-if="index >= 0" class="remove-business-photo" @click="removePhoto"
      color="red accent-3" text>
      <v-icon>fas fa-minus-circle</v-icon>
    </v-btn>
  </v-flex>
  <v-flex v-else>
    <v-row>
      <v-select label="Category" :items="categories"></v-select>
    </v-row>
    <v-row>
      <v-col>
        <v-btn v-if="titleEditor && !showEditor" class="remove-business-photo mb-3" @click="showEditor = !showEditor;"
          color="orange accent-3" text>
          <v-icon>fas fa-edit</v-icon>
        </v-btn>
        <v-btn v-else-if="titleEditor && showEditor" class="remove-business-photo mb-3" @click="showEditor = !showEditor;"
          color="green accent-3" text>
          <v-icon>fas fa-check-circle</v-icon>
        </v-btn>
        <v-btn class="remove-business-photo" @click="removePhoto"
          color="red accent-3" text>
          <v-icon>fas fa-minus-circle</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-flex>
</template>

<script>
export default {
  data: () => ({
    showEditor: false
  }),
  props: {
    index: {
      type: Number,
      default: -1,
    },
    multiFlag: {
      type: Boolean,
      default: true
    },
    photo: {
      type: String,
    },
    title: {
      type: String,
      default: ''
    },
    titleEditor: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'SQUARE'
    },
    categories: {
      type: Array,
      default: () => {
        return ['1', '2', '3']
      }
    }
  },
  methods: {
    removePhoto() {
      this.showEditor = false;
      this.$emit('remove-business-photo', this.index);
    },
    addPhoto($event) {
      this.$emit('add-photo', $event.target.files);
    },
    addCardClick() {
      console.log('add-card-click');
      this.$refs['addPhotoInput'].click();
    },
    changePhoto(index) {
      const refName = 'BP' + index;
      console.log(refName);
      this.$refs[refName].click();
    },
    uploadPhoto(index, $event) {
      console.log('upload photo: ' + index);
      this.$emit('update-photo', {photoIndex: index, photoFile: $event.target.files[0]});
    },
  },
};
</script>
